// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/account_management/bank_switch/firstparty/v1/movable_payment.proto

/* oxlint-disable */

/** Migration status of a movable payment. */
export const ApiStatus = {
  /** STATUS_UNSPECIFIED - Unspecified status. */
  STATUS_UNSPECIFIED: "STATUS_UNSPECIFIED",
  /**
   * No action has been performed on the movable payment yet.
   */
  pending: "pending",
  /**
   * The user indicated that the payment has been migrated.
   */
  moved: "moved",
  /**
   * The user dismissed this movable payment.
   */
  dismissed: "dismissed",
} as const;

export type ApiStatus = typeof ApiStatus[keyof typeof ApiStatus];

export namespace ApiStatus {
  export type STATUS_UNSPECIFIED = typeof ApiStatus.STATUS_UNSPECIFIED;
  export type pending = typeof ApiStatus.pending;
  export type moved = typeof ApiStatus.moved;
  export type dismissed = typeof ApiStatus.dismissed;
}

export function apiStatusFromJSON(object: any): ApiStatus {
  switch (object) {
    case 0:
    case "STATUS_UNSPECIFIED":
      return ApiStatus.STATUS_UNSPECIFIED;
    case 1:
    case "pending":
      return ApiStatus.pending;
    case 2:
    case "moved":
      return ApiStatus.moved;
    case 3:
    case "dismissed":
      return ApiStatus.dismissed;
    default:
      return ApiStatus.STATUS_UNSPECIFIED;
  }
}

export function apiStatusToJSON(object: ApiStatus): string {
  switch (object) {
    case ApiStatus.STATUS_UNSPECIFIED:
      return "STATUS_UNSPECIFIED";
    case ApiStatus.pending:
      return "pending";
    case ApiStatus.moved:
      return "moved";
    case ApiStatus.dismissed:
      return "dismissed";
    default:
      return "STATUS_UNSPECIFIED";
  }
}

/** The type of payment from the external bank account. */
export const ApiOperationType = {
  /** OPERATION_TYPE_UNSPECIFIED - Unspecified operation type. */
  OPERATION_TYPE_UNSPECIFIED: "OPERATION_TYPE_UNSPECIFIED",
  /**
   * Payment is operated via a card.
   */
  card: "card",
} as const;

export type ApiOperationType = typeof ApiOperationType[keyof typeof ApiOperationType];

export namespace ApiOperationType {
  export type OPERATION_TYPE_UNSPECIFIED = typeof ApiOperationType.OPERATION_TYPE_UNSPECIFIED;
  export type card = typeof ApiOperationType.card;
}

export function apiOperationTypeFromJSON(object: any): ApiOperationType {
  switch (object) {
    case 0:
    case "OPERATION_TYPE_UNSPECIFIED":
      return ApiOperationType.OPERATION_TYPE_UNSPECIFIED;
    case 1:
    case "card":
      return ApiOperationType.card;
    default:
      return ApiOperationType.OPERATION_TYPE_UNSPECIFIED;
  }
}

export function apiOperationTypeToJSON(object: ApiOperationType): string {
  switch (object) {
    case ApiOperationType.OPERATION_TYPE_UNSPECIFIED:
      return "OPERATION_TYPE_UNSPECIFIED";
    case ApiOperationType.card:
      return "card";
    default:
      return "OPERATION_TYPE_UNSPECIFIED";
  }
}

/**
 * A recurring payment detected on an external bank account that the user may
 * want to migrate onto their Qonto account.
 */
export interface ApiMovablePayment {
  /** Unique identifier of the movable payment. */
  readonly id: string;
  /** Merchant behind the recurring payment. */
  readonly merchant:
    | ApiMerchant
    | null;
  /** The type of payment from the external bank account. */
  readonly operationType: ApiOperationType;
  /** External bank account where the payment was detected. */
  readonly externalBankAccount:
    | ApiExternalBankAccount
    | null;
  /** Aggregated information about the external transactions backing this movable payment. */
  readonly externalBankTransactions:
    | ApiExternalBankTransactions
    | null;
  /** Current migration status of the movable payment. */
  readonly status: ApiStatus;
  /** When the movable payment was created, as an ISO 8601 date (YYYY-MM-DD). */
  readonly createdAt: string;
  /**
   * When the user marked the payment as moved, as an ISO 8601 date (YYYY-MM-DD).
   * Unset until status becomes MOVED.
   */
  readonly movedAt?: string | null | undefined;
}

/** Merchant behind a recurring payment. */
export interface ApiMerchant {
  /** Display name of the merchant. */
  readonly name: string;
  /** URL of the merchant logo. */
  readonly logoUrl: string;
  /** URL the user should be redirected to in order to update their payment method. */
  readonly redirectUrl: string;
}

/** External bank account where the recurring payment was detected. */
export interface ApiExternalBankAccount {
  /** Display name of the external bank. */
  readonly name: string;
  /** URL of the external bank logo. */
  readonly logoUrl: string;
}

/** Aggregated transaction information backing a movable payment. */
export interface ApiExternalBankTransactions {
  /** Number of transactions detected for this recurring payment. */
  readonly transactionCount: number;
  /** Period, in days, over which the transactions were aggregated. */
  readonly periodDays: number;
}

export const ApiMovablePayment: MessageFns<ApiMovablePayment> = {
  fromJSON(object: any): ApiMovablePayment {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      merchant: isSet(object.merchant) ? ApiMerchant.fromJSON(object.merchant) : null,
      operationType: isSet(object.operation_type)
        ? apiOperationTypeFromJSON(object.operation_type)
        : ApiOperationType.OPERATION_TYPE_UNSPECIFIED,
      externalBankAccount: isSet(object.external_bank_account)
        ? ApiExternalBankAccount.fromJSON(object.external_bank_account)
        : null,
      externalBankTransactions: isSet(object.external_bank_transactions)
        ? ApiExternalBankTransactions.fromJSON(object.external_bank_transactions)
        : null,
      status: isSet(object.status) ? apiStatusFromJSON(object.status) : ApiStatus.STATUS_UNSPECIFIED,
      createdAt: isSet(object.created_at) ? globalThis.String(object.created_at) : "",
      movedAt: isSet(object.moved_at) ? globalThis.String(object.moved_at) : null,
    };
  },

  toJSON(message: ApiMovablePayment): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.merchant !== undefined && message.merchant !== null) {
      obj.merchant = ApiMerchant.toJSON(message.merchant);
    }
    if (message.operationType !== undefined && message.operationType !== null) {
      obj.operation_type = apiOperationTypeToJSON(message.operationType);
    }
    if (message.externalBankAccount !== undefined && message.externalBankAccount !== null) {
      obj.external_bank_account = ApiExternalBankAccount.toJSON(message.externalBankAccount);
    }
    if (message.externalBankTransactions !== undefined && message.externalBankTransactions !== null) {
      obj.external_bank_transactions = ApiExternalBankTransactions.toJSON(message.externalBankTransactions);
    }
    if (message.status !== undefined && message.status !== null) {
      obj.status = apiStatusToJSON(message.status);
    }
    if (message.createdAt !== undefined && message.createdAt !== null) {
      obj.created_at = message.createdAt;
    }
    if (message.movedAt !== undefined && message.movedAt !== null) {
      obj.moved_at = message.movedAt;
    }
    return obj;
  },
};

export const ApiMerchant: MessageFns<ApiMerchant> = {
  fromJSON(object: any): ApiMerchant {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      logoUrl: isSet(object.logo_url) ? globalThis.String(object.logo_url) : "",
      redirectUrl: isSet(object.redirect_url) ? globalThis.String(object.redirect_url) : "",
    };
  },

  toJSON(message: ApiMerchant): unknown {
    const obj: any = {};
    if (message.name !== undefined && message.name !== null) {
      obj.name = message.name;
    }
    if (message.logoUrl !== undefined && message.logoUrl !== null) {
      obj.logo_url = message.logoUrl;
    }
    if (message.redirectUrl !== undefined && message.redirectUrl !== null) {
      obj.redirect_url = message.redirectUrl;
    }
    return obj;
  },
};

export const ApiExternalBankAccount: MessageFns<ApiExternalBankAccount> = {
  fromJSON(object: any): ApiExternalBankAccount {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      logoUrl: isSet(object.logo_url) ? globalThis.String(object.logo_url) : "",
    };
  },

  toJSON(message: ApiExternalBankAccount): unknown {
    const obj: any = {};
    if (message.name !== undefined && message.name !== null) {
      obj.name = message.name;
    }
    if (message.logoUrl !== undefined && message.logoUrl !== null) {
      obj.logo_url = message.logoUrl;
    }
    return obj;
  },
};

export const ApiExternalBankTransactions: MessageFns<ApiExternalBankTransactions> = {
  fromJSON(object: any): ApiExternalBankTransactions {
    return {
      transactionCount: isSet(object.transaction_count) ? globalThis.Number(object.transaction_count) : 0,
      periodDays: isSet(object.period_days) ? globalThis.Number(object.period_days) : 0,
    };
  },

  toJSON(message: ApiExternalBankTransactions): unknown {
    const obj: any = {};
    if (message.transactionCount !== undefined && message.transactionCount !== null) {
      obj.transaction_count = Math.round(message.transactionCount);
    }
    if (message.periodDays !== undefined && message.periodDays !== null) {
      obj.period_days = Math.round(message.periodDays);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
